import axios from 'axios';
import React, { useRef, useState } from 'react'
import { Button, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie';
import ImageUploading from 'react-images-uploading';

const CreateTicket = (props) => {
    const [showBox, setShowBox] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [photo, setPhoto] = useState('')
    const [forceUpdate, setForceUpdate] = useState(0)
    const [uploadPercentage, setUploadPercentage] = useState(0)
    const [progerssbar, setProgressbar] = useState(0)
    const [images, setImages] = useState([]);
    const maxNumber = 10;
    const [selectedImage, setSelectedImage] = useState();
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState({
        subject: '',
        message: '',
        priority: '',
    })
    const dispatch = useDispatch()
    const {t} = useTranslation();

    const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
    };

    const handleDataChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleSelectImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
        setPhoto(e.target.files[0])
    }

    const removeSelectedImage = () => {
        setSelectedImage();
        setPhoto()
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleCreateTicket = () => {
        setShowBox(true)
        window.scrollTo(0, 200)
    }

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setProgressbar(true)
            setBtnLoading(false)
            dispatch(fetchCsrfCookie())

            const formData = new FormData();
            formData.append('subject', data.subject)
            formData.append('message', data.message)
            formData.append('priority', data.priority)
            formData.append('image', photo)

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },

                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor( (loaded * 100) / total )
            
                    if( percent < 100 ){
                        setUploadPercentage(percent)
                    }
                }
            }

            axios.post(`co/tickets`, formData, config)
            .then(res => {
                window.scrollTo(0, 0)
                if (res.status === 201) {
                    toast.dismiss()	
                    toast.error(t("toast You have three open tickets and it is not possible to open a new ticket") , {position: 'bottom-right',className: 'foo-bar'})
                    setPhoto()
                    setShowBox(false)
                    setData({
                        subject: '',
                        message: '',
                        priority: '',
                    })
                } else {
                    setUploadPercentage(100)
                    setTimeout(() => {
                        setUploadPercentage(0)
                    }, 1000);
                    setPhoto()
                    toast.dismiss()	
                    toast.success(t("toast_successfully_sent") , {position: 'bottom-right',className: 'foo-bar'})
                    setShowBox(false)
                    setData({
                        subject: '',
                        message: '',
                        priority: '',
                    })
                    props.update()
                }
            })
            .catch(err => {
                setBtnLoading(false)
                console.log(err)
                if(err.response) {
                    if(err.response.status === 403) {
                        setPhoto()
                        setSelectedImage()
                        setProgressbar()
                        toast.dismiss()
                        toast.error(t("toast_content_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
                    } else {
                        setPhoto()
                        setSelectedImage()
                        setProgressbar()
                        toast.dismiss()
                        toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
                    }
                }
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <div className='create_ticket_wrapper'>
            <div className="col-12 create_btn my-5 d-flex justify-content-end">
                <button className="btn btn-success" onClick={handleCreateTicket}> {t("create ticket")} <i className="fa fa-plus"></i></button>
            </div>
            {showBox &&
                <Form className='col-lg-7' onSubmit={handleFromSubmit}>
                    <Form.Group className="mb-3" controlId="formSubject">
                        <Form.Label><strong>{t("title")} :</strong></Form.Label>
                        <Form.Control type="text" name="subject" value={data.subject} onChange={handleDataChange}  />
                        <span className='validator_error'>{validator.current.message('subject', data.subject, 'required')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.Controlmessage">
                        <Form.Label><strong>{t("text")} :</strong></Form.Label>
                        <Form.Control as="textarea" rows={3} name="message" value={data.message} onChange={handleDataChange} />
                        <span className='validator_error'>{validator.current.message('message', data.message, 'required')}</span>
                    </Form.Group>
                    <Form.Select name="priority" value={data.priority} onChange={handleDataChange}>
                        <option>{t("Importance")}</option>
                        <option value="LOW">{t("low")}</option>
                        <option value="MID">{t("mid")}</option>
                        <option value="HIGH">{t("high")}</option>
                    </Form.Select>
                    <span className='validator_error'>{validator.current.message('priority', data.priority, 'required')}</span>

                    <Row>
                        <div className='mt-4'>
                            <p>{t("The maximum accepted image size is 2 MB")}</p>
                            <p>{t("The_selected_image_format_must_be_one_of_the_following_jpeg_png_jpg_gif_svg")}</p>
                        </div>
                        {/* <ImageUploading
                            multiple
                            value={images}
                            onChange={onChange}
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                        >
                            {({
                            imageList,
                            onImageUpload,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                            }) => (
                            <div className="upload__image-wrapper">
                                <button
                                className='btn btn-primary btn-sm mb-3 px-3 py-2'
                                type='button'
                                style={isDragging ? { color: 'red' } : undefined}
                                onClick={onImageUpload}
                                {...dragProps}
                                >
                               {t(("choose picture"))}
                                </button>
                                <div className='choosed_images'>
                                {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                    <img src={image['data_url']} alt="ticket-image" />
                                    <div className="image-item__btn-wrapper">
                                        <button type='button' className='btn btn-danger btn-sm px-2' onClick={() => onImageUpdate(index)}>{t("change picture")}</button>
                                        <button type='button' className='btn btn-danger btn-sm px-2 mx-1' onClick={() => onImageRemove(index)}>{t("delete")}</button>
                                    </div>
                                </div>
                                ))}
                                </div>
                            </div>
                            )}
                        </ImageUploading> */}


                        {selectedImage ? 
                            <>
                                <div className='selectedImage col-lg-3'>
                                    <img
                                        src={URL.createObjectURL(selectedImage)}
                                        alt="Thumb"
                                    />
                                    <button className='btn btn-danger remove_selected_image' type='button' onClick={removeSelectedImage}>
                                        <i className='fa fa-times'></i>
                                    </button>
                                </div>
                                
                            </>
                        :
                            <div className='selectImage col-lg-3'>
                                <div className='chooseForm'>
                                    <input type="file" className='create_new_image_input' name="photo" value={photo} onChange={handleSelectImage}/>
                                    <i className='fa fa-plus'></i>
                                    <span>{t("choose picture")}</span>
                                </div>
                            </div>
                        }

                    </Row>
                    <Button variant="success" type="submit" className='px-4 mt-2' disabled={btnLoading ? true : false}>
                        {t("send")}
                    </Button>
                </Form>
            }
        </div>
    )
}

export default CreateTicket;